module.exports = __webpack_public_path__ + "img/bgSocialSecurity.2b77ed5f.png";